import {getCellValue} from "../../../../utils/utils";
import Icon from "../../general/icon";
import {general} from "../../../../store/action";
import {connect, useSelector} from "react-redux";
import React, {useEffect} from "react";
import Tooltip from "../../general/tooltip";
import {useFindAccessInAccessList} from "../../../../constants/constant/accessProcess";
import {useGetFilledPrescriptionPrint} from "../../../../hook/request/ihioPrescriptionFilling";
import {convertBase64ToFile, downloadFile} from "../../../../utils/fileConvertor";
import {TGIdNameData} from "../../../../types/general";

type PrescriptionFillingTableRowItemProps = {
    item: any;
    handleShowModal: any;
}

const PrescriptionFillingTableRowItem = ({
    item,
    handleShowModal
}: PrescriptionFillingTableRowItemProps) => {

    const isProvider = useSelector((state: any) => state.general.userDataReducer.isProvider);
    const {findAccessInAccessList} = useFindAccessInAccessList();
    const getFilledPrescriptionPrintRequest = useGetFilledPrescriptionPrint()

    useEffect(() => {
        if(getFilledPrescriptionPrintRequest?.isSuccess && getFilledPrescriptionPrintRequest?.data?.data?.result) {
            handleDownloadIhioPrintPrescription(getFilledPrescriptionPrintRequest?.data?.data?.result?.file, getFilledPrescriptionPrintRequest?.data?.data?.result?.type)
        }
    }, [getFilledPrescriptionPrintRequest?.data?.data?.result]);

    const handleDownloadIhioPrintPrescription = (base64Data: any, type: TGIdNameData) => {
        const file = convertBase64ToFile(
            base64Data,
            `نسخه ${type?.name} - ${item?.firstName} ${item?.lastName} - ${item?.deliveredDate}`,
            'application/pdf'
        )
        downloadFile(file);
    };

    const handlePrintPrescription = () => {
        const body = {
            nationalCode: item.nationalNumber || '',
            trackingCode: item.trackingCode || '',
            checkCode: item.checkCode || '',
        }
        getFilledPrescriptionPrintRequest.mutate(body)
    }

    return (
        <tr>
            <td>{getCellValue(item?.firstName)} {getCellValue(item?.lastName)}</td>
            <td>{getCellValue(item?.nationalNumber)}</td>
            <td>{getCellValue(item?.deliveredDate)}</td>
            <td>{getCellValue(item?.trackingCode)}</td>
            <td>{getCellValue(item?.sequenceNumber)}</td>
            <td>
                <div className="d-flex justify-content-center align-items-center">
                    <Tooltip alt={"چاپ نسخه"} className="tooltip-pre-line">
                        <span
                            onClick={() =>
                                handlePrintPrescription()
                            }
                            className={`d-flex mx-2 font-20 cur-pointer text-hover`}
                        >
                          <Icon name='document'/>
                        </span>
                    </Tooltip>
                    <Tooltip alt={"مشاهده"} className="tooltip-pre-line">
                        <span
                            onClick={() =>
                                handleShowModal('filledPrescriptionDeliverInfoModal', {checkCode: item?.checkCode})
                            }
                            className={`d-flex mx-2 font-20 cur-pointer text-hover`}
                        >
                          <Icon name='eye'/>
                        </span>
                    </Tooltip>
                </div>
            </td>
        </tr>
    )
}

const mapDispatchToProps = (dispatch: any) => ({
    handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PrescriptionFillingTableRowItem);
